/**
 * otr-lm-widget.js
 * One Thousand Roads — Blog Lead Magnet Widget
 *
 * USAGE:
 *   <div class="otr-lm" data-guide="ewot" data-form="XXfwZP"
 *        data-headline="Want the Full Protocol?"
 *        data-subhead="Get the free EWOT Guide — everything behind the benefits on this page."></div>
 *
 * ATTRIBUTES:
 *   data-guide     — guide slug (ewot | ewot-buyers | rlt | oss | lyme)
 *   data-form      — Klaviyo form ID
 *   data-headline  — short bold headline (overrides guide default)
 *   data-subhead   — supporting sentence below headline (overrides guide default)
 *
 * GUIDE SLUGS → FORM IDs:
 *   ewot        → XXfwZP
 *   ewot-buyers → YaT3S3
 *   rlt         → VSyShJ
 *   oss         → TehVdG
 *   lyme        → TyGszh
 *
 * INSTALL (theme.liquid, before </body>):
 *   {% if template.name == 'article' %}
 *     <script src="{{ 'otr-lm-widget.js' | asset_url }}" defer></script>
 *   {% endif %}
 */

(function () {
  'use strict';

  var GUIDES = {
    'ewot': {
      img: 'https://cdn.shopify.com/s/files/1/0097/3186/6683/files/The_Oxygen_Advantage_Protocol.webp?v=1780236445',
      alt: 'The Oxygen Advantage Protocol — free EWOT guide cover',
      headline: 'Get the Free EWOT Guide',
      subhead: 'Learn the complete protocol — boost cellular energy and oxygen delivery in 15 minutes a day.'
    },
    'ewot-buyers': {
      img: 'https://cdn.shopify.com/s/files/1/0097/3186/6683/files/Buyers_Guide_Cover.webp?v=1783880999',
      alt: 'EWOT Buyers Guide — free guide cover',
      headline: 'Not Sure Which System?',
      subhead: 'The free Buyers Guide walks through every EWOT option by goal, budget, and setup.'
    },
    'rlt': {
      img: 'https://cdn.shopify.com/s/files/1/0097/3186/6683/files/Unlock_the_Full_Power_of_RLT.webp?v=1780238005',
      alt: 'Unlock the Full Power of Red Light Therapy — free guide cover',
      headline: 'Get the Free RLT Guide',
      subhead: 'How to use red light therapy at home for maximum mitochondrial impact.'
    },
    'oss': {
      img: 'https://cdn.shopify.com/s/files/1/0097/3186/6683/files/Synergy_Guide_Cover.webp?v=1784068603',
      alt: 'The Synergistic Power of EWOT + Red Light Therapy — free guide cover',
      headline: 'Get the Free Synergy Guide',
      subhead: 'How to stack EWOT + red light therapy for the complete Oxygen Synergy protocol.'
    },
    'lyme': {
      img: 'https://cdn.shopify.com/s/files/1/0097/3186/6683/files/Lyme_eBook.webp?v=1780235430',
      alt: 'The Simpler Path to Lyme Recovery — free guide cover',
      headline: 'Get the Free Lyme Guide',
      subhead: 'A simpler path to Lyme recovery using oxygen and light therapy.'
    }
  };

  function buildWidget(el) {
    var guide    = el.getAttribute('data-guide');
    var formId   = el.getAttribute('data-form');
    var config   = GUIDES[guide];

    if (!config || !formId) {
      if (console && console.warn) {
        console.warn('[otr-lm] Unknown guide "' + guide + '" or missing data-form on', el);
      }
      return;
    }

    var headline = el.getAttribute('data-headline') || config.headline;
    var subhead  = el.getAttribute('data-subhead')  || config.subhead;

    el.innerHTML =
      '<div class="otr-lm-inner">' +

        '<div class="otr-lm-img-col" aria-hidden="true">' +
          '<div class="otr-lm-img-wrap">' +
            '<img' +
              ' class="otr-lm-cover"' +
              ' src="'   + config.img + '"' +
              ' alt="'   + config.alt + '"' +
              ' loading="lazy"' +
              ' decoding="async"' +
            '>' +
          '</div>' +
        '</div>' +

        '<div class="otr-lm-form-col">' +
          '<div class="otr-lm-form-inner">' +
            (headline ? '<p class="otr-lm-headline">' + headline + '</p>' : '') +
            (subhead  ? '<p class="otr-lm-subhead">'  + subhead  + '</p>' : '') +
            '<div class="klaviyo-form-' + formId + '"></div>' +
          '</div>' +
        '</div>' +

      '</div>';

    try {
      if (window._klOnsite) {
        window._klOnsite.push(['account', null]);
      }
    } catch (e) {}
  }

  function init() {
    var widgets = document.querySelectorAll('.otr-lm[data-guide]');
    for (var i = 0; i < widgets.length; i++) {
      buildWidget(widgets[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();